<template>
    <div>
        <v-layout
            row
            wrap
            class="filter-options__filters"
            mt-3>
            <v-flex
                xs12
                sm3
                pr-3
                v-if="countryList && countryList.length">
                <v-select
                    clearable
                    hide-details
                    :items="countryList"
                    item-text="label"
                    data-qe-id="member-directory_location_country-dropdown"
                    :label="memberDirectoryPageConstant.label.SELECT_COUNTRY"
                    return-object
                    v-model="selectedLocation.country"
                    :menu-props="{
                        maxHeight: '300px',
                        minWidth: '408px',
                        offsetY: true,
                        closeOnContentClick: false
                    }"
                    @change="changedCountry"></v-select>
            </v-flex>
            <v-flex
                xs12
                sm3
                pr-3
                v-if="stateList && stateList.length">
                <v-select
                    clearable
                    hide-details
                    :items="stateList"
                    item-text="label"
                    data-qe-id="member-directory_location_state-dropdown"
                    :label="memberDirectoryPageConstant.label.SELECT_STATE"
                    return-object
                    v-model="selectedLocation.state"
                    :menu-props="{
                        maxHeight: '300px',
                        minWidth: '408px',
                        offsetY: true,
                        closeOnContentClick: false
                    }"
                    @change="changedState"></v-select>
            </v-flex>
            <v-flex
                xs12
                sm3
                pr-2
                class="location-type-ahead">
                <v-text-field
                    v-if="selectedTypeAhead"
                    class="filter-options__typeAhead-input"
                    data-qe-id="member-directory_location_city_input"
                    hide-details
                    @keyup="getTypeAheadResult"
                    :label="(typeAheadItem && typeAheadItem.inputLabel) || ''"
                    :placeholder="selectedTypeAhead.placeHolder"
                    v-model="selectedTypeAhead.searchText">
                </v-text-field>
                <v-layout column class="filter-options__typeAhead-result inner-scrollbar"
                          v-if="selectedTypeAhead && selectedTypeAhead.searchText && selectedTypeAhead.searchText.length > 2">
                    <status-overlay :action="typeAheadAction" content-height="60px"></status-overlay>
                    <v-flex
                        xs4
                        class="filter-options__typeAhead-result--item"
                        v-if="typeAheadResultForCities && typeAheadResultForCities.length > 0"
                        v-for="(searchItem, index) in typeAheadResultForCities"
                        :key="getRandomId(index)"
                        pa-2>
                        <label class="check-container ypo_blue_color">
                            <span>{{searchItem.label}}</span>
                            <input type="checkbox"
                                   :value="searchItem"
                                   :data-qe-id="`member-directory_location_city_search-result-${index}_checkbox`"
                                   v-model="ribbonState[filterItem.key]"
                                   @change="checkCityCheckbox(searchItem)">
                            <span class="checkmark"></span>
                        </label>
                    </v-flex>
                    <v-flex
                        xs4
                        pa-2
                        v-if="selectedTypeAhead && selectedTypeAhead.searchResult && typeAheadResultForCities && typeAheadResultForCities.length === 0"
                        class="bold-font ypo_blue_color">
                        {{memberDirectoryPageConstant.label.NO_TYPE_AHEAD_RESULT_FOUND}}
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-flex
            xs12
            pa-2
            mt-3
            class="filter-options__typeAhead-previous"
            v-if="selectedTypeAhead && selectedTypeAhead.previouslySelected && selectedTypeAhead.previouslySelected.length > 0">
            <v-layout row wrap>
                <v-flex
                    xs3
                    v-for="(selectedItem, index) in selectedTypeAhead.previouslySelected"
                    :key="getRandomId(index)"
                    pa-2>
                    <label class="check-container ypo_blue_color">
                        <span>{{labelForPreviouslySelected(selectedItem)}}</span>
                        <input type="checkbox"
                               :value="selectedItem"
                               :data-qe-id="`member-directory_location_previously-selected-${index}_checkbox`"
                               v-model="ribbonState[filterItem.key]">
                        <span class="checkmark"></span>
                    </label>
                </v-flex>
            </v-layout>
        </v-flex>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { memberDirectoryPageConstant, typeAheadForMemberDirectory } from "../memberDirectoryPage.constants";
    import { getRandomId } from "../../../common/utils/utils";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import StatusOverlay from "../../StatusOverlay/StatusOverlay";
    import uniqBy from 'lodash/uniqBy';
    import debounce from 'lodash/debounce';

    export default {
        name: "MemberLocation",
        components: {
            StatusOverlay,
        },
        props: {
            filterItem: {
                type: Object,
                required: true,
            },
        },
        created() {
            if (this.ribbonState && this.ribbonState[this.filterItem.key]) {
                this.previouslyAddedFilters.push(...this.ribbonState[this.filterItem.key]);
            }
        },
        data() {
            return {
                memberDirectoryPageConstant,
                selectedLocation: {
                    country: null,
                    state: null,
                    city: [],
                },
                isLocation: this.filterItem.key === memberDirectoryPageConstant.constant.memberLocationKey,
                previouslyAddedFilters: [],
            };
        },
        watch: {
            cityTypeAheadFilter() {
              debounce(this.clearTypeAheadData, 500);
            },
            checkRibbonStateForCity() {
                //this.checkCountryState();
            },
        },
        methods: {
            ...mapMutations({
                setSelectedTypeAhead: `memberDirectory/${storeMutation.setSelectedTypeAhead}`,
                setMemberDirectoryTypeAhead: `memberDirectory/${storeMutation.setMemberDirectoryTypeAhead}`,
            }),
            getRandomId,
            ...mapActions({
                initiateTypeAheadSearch: `memberDirectory/${storeAction.initiateTypeAheadSearch}`,
            }),
            ...mapMutations({
                resetTypeAheadResult: `memberDirectory/${storeMutation.resetTypeAheadResult}`,
            }),
            getTypeAheadResult() {
                if (this.selectedTypeAhead &&
                    this.selectedTypeAhead.searchText &&
                    this.selectedTypeAhead.searchText.length < 3) {
                    this.resetTypeAheadResult();
                }

                if (this.selectedTypeAhead && this.selectedTypeAhead.searchText && this.selectedTypeAhead.searchText.length > 2) {
                    const typeAheadObject = {
                        searchText: this.selectedTypeAhead.searchText,
                        additionalFilters: null,
                        typeAheadAdditionalFilter: this.cityTypeAheadFilter,
                    };
                    this.initiateTypeAheadSearch(typeAheadObject)
                        .catch(() => {});
                }
            },
            updateSelectedCityList(cityList) {
                if (cityList) {
                    const filteredCities = [];
                    cityList.forEach((city) => {
                        const alreadyExists = this.localFilterState
                            .find(ct => ct.filterKey === city.filterKey && ct.filterValue === city.filterValue);
                        if (!alreadyExists) {
                            filteredCities.push(city);
                        }
                    });
                    this.selectedLocation.city = [...filteredCities];
                }
            },
            clearTypeAheadData() {
                this.selectedTypeAhead.searchText = '';
                this.selectedTypeAhead.searchResult = null;
            },
            changedCountry(country) {
                if (country) {
                    this.ribbonState[this.filterItem.key] = [];
                    const countryAlreadyExist = this.previouslyAddedFilters.some(item => item.filterKey === country.filterKey && item.filterValue === country.filterValue);
                    if (countryAlreadyExist) {
                        this.ribbonState[this.filterItem.key].push(...this.previouslyAddedFilters);
                    } else {
                        this.ribbonState[this.filterItem.key].push(country, ...this.previouslyAddedFilters);
                    }
                } else {
                    this.ribbonState[this.filterItem.key] = [];
                    this.ribbonState[this.filterItem.key].push(...this.previouslyAddedFilters);
                    this.selectedLocation.country = null;
                    this.selectedLocation.state = null;
                }
            },
            changedState(state) {
                if (state) {
                    this.ribbonState[this.filterItem.key] = [];
                    const stateAlreadyExist = this.previouslyAddedFilters.some(item => item.filterKey === state.filterKey && item.filterValue === state.filterValue);
                    if (stateAlreadyExist) {
                        this.ribbonState[this.filterItem.key].push(...this.previouslyAddedFilters);
                    } else {
                        this.ribbonState[this.filterItem.key].push(state, ...this.previouslyAddedFilters);
                    }
                } else {
                    this.ribbonState[this.filterItem.key] = [];
                    this.ribbonState[this.filterItem.key].push(this.selectedLocation.country, ...this.previouslyAddedFilters);
                }
            },
            checkCityCheckbox() {
                if (!this.ribbonState[this.filterItem.key].length) {
                    if (this.cityTypeAheadFilter) {
                        this.ribbonState[this.filterItem.key].push(this.cityTypeAheadFilter, ...this.previouslyAddedFilters);
                    }
                } else if (this.ribbonState[this.filterItem.key].length) {
                    if (!this.previouslyAddedFilters.length) {
                        const newItems = this.ribbonState[this.filterItem.key].filter(item => item.filterKey !== memberDirectoryPageConstant.constant.combinedCountryStateKey);
                        this.ribbonState[this.filterItem.key] = [];
                        this.ribbonState[this.filterItem.key].push(...newItems);
                    } else {
                        let newSelectedItems = this.ribbonState[this.filterItem.key]
                            .filter(item => !this.previouslyAddedFilters.find(it => item.filterKey === it.filterKey && item.filterValue === it.filterValue));
                        const selectedCities = newSelectedItems.filter(item => item.filterKey !== memberDirectoryPageConstant.constant.combinedCountryStateKey);
                        if (selectedCities && selectedCities.length) {
                            newSelectedItems = [...selectedCities];
                            this.ribbonState[this.filterItem.key] = [];
                            this.ribbonState[this.filterItem.key].push(...newSelectedItems, ...this.previouslyAddedFilters);
                        } else if (this.cityTypeAheadFilter) {
                            this.ribbonState[this.filterItem.key] = [];
                            this.ribbonState[this.filterItem.key].push(this.cityTypeAheadFilter, ...this.previouslyAddedFilters);
                        }
                    }
                }
            },
            labelForPreviouslySelected(location) {
                let newLabel = location.label;
                if (location.filterKey === memberDirectoryPageConstant.constant.combinedCountryStateKey) {
                    const dividerIndex = location.filterValue.indexOf('>');
                    if (dividerIndex > 0) {
                        newLabel = `${location.filterValue.substring(0, dividerIndex)}, ${location.label}`;
                    }
                }
                return newLabel;
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                ribbonState: `memberDirectory/${storeGetters.ribbonState}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
                selectedTypeAhead: `memberDirectory/${storeGetters.selectedTypeAhead}`,
            }),
            typeAheadResultForCities() {
                let result = [];
                if (this.selectedTypeAhead && this.selectedTypeAhead.searchResult && this.selectedTypeAhead.searchResult.length) {
                    if (this.previouslyAddedFilters.length) {
                        result = this.selectedTypeAhead.searchResult
                            .filter(item => !this.previouslyAddedFilters.find(it => item.filterKey === it.filterKey && item.filterValue === it.filterValue));
                    } else {
                        result = [...this.selectedTypeAhead.searchResult];
                    }
                }
                return result;
            },
            checkRibbonStateForCity() {
                if (this.selectedLocation.country) {
                    return true;
                }
                if (this.selectedLocation.state) {
                    return true;
                }
                if (this.ribbonState[this.filterItem.key]) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.selectedLocation.city = [...this.ribbonState[this.filterItem.key]];
                }
                return this.selectedLocation.city;
            },
            countryList() {
                let countryList = null;
                if (this.filterItem && this.filterItem.filters && this.filterItem.filters.length) {
                    const countryFilter = this.filterItem.filters.find(item => item.isDropdown);
                    if (countryFilter && countryFilter.subFilters) {
                        countryList = countryFilter.subFilters;
                    }
                }
                return countryList;
            },
            stateList() {
                return this.countryList && this.selectedLocation.country &&
                    this.selectedLocation.country.subFilters && this.selectedLocation.country.subFilters.length ?
                    this.selectedLocation.country.subFilters :
                    [];
            },
            cityTypeAhead() {
                let cityTypehead = null;
                if (this.filterItem && this.filterItem.filters && this.filterItem.filters.length) {
                    const typeAheadItem = this.filterItem.filters.find(item => item.isTypeAhead);
                    if (typeAheadItem) {
                        cityTypehead = { ...typeAheadItem };
                    }
                }
                return cityTypehead;
            },
            cityTypeAheadFilter() {
                let filters = null;
                if (this.selectedLocation.state) {
                    filters = this.selectedLocation.state;
                } else if (this.selectedLocation.country) {
                    filters = this.selectedLocation.country;
                }
                return filters;
            },
            selectedLocationData() {
                const { country, state, city } = this.selectedLocation;
                let selected = [];
                if (this.selectedLocation) {
                    if (city && city.length) {
                        selected = [...city];
                    } else if (country && country.hasOwnProperty('filterKey') && (!city || !city.length)) {
                        if (state && state.hasOwnProperty('filterKey')) {
                            selected = [state];
                        } else {
                            selected = [country];
                        }
                    }
                }
                selected = [...selected, ...this.localFilterState];
                return uniqBy(selected, 'filterValue');
            },
            typeAheadItem() {
                let typeAheadItem = null;
                if (this.selectedTypeAhead) {
                    typeAheadItem = typeAheadForMemberDirectory.find(item => item.key === this.selectedTypeAhead.key);
                }
                return typeAheadItem;
            },
            typeAheadAction() {
                return this.actions[storeAction.initiateTypeAheadSearch];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';

    .filter-options {
        background-color: $ypo-extra-light-gray;
        @extend %ypo_checkbox;

        &__filters {
            background-color: $white;
            padding: 20px 40px;
        }

        &__typeAhead {
            margin-top: 20px;

            &-input {
                background-color: $white;
                margin-top: 0;
            }

            &-result {
                background-color: $white;
                border: 1px solid $ypo-tile-border;
                padding: 10px;
                border-top: none;
                width: 98%;
                margin-left: 1%;
                min-height: 60px !important;
                position: relative;
                max-height: 220px !important;
                overflow: auto;
                box-shadow: 0 2px 4px 0 rgba($black, 0.5);

                &--item {
                    max-height: 40px !important;
                }
            }

            &-previous {
                background-color: $white;
                border: 1px solid $ypo-tile-border;
                padding-left: 10px;
            }
        }

        &__subFilters {
            &-options {
                background-color: $white;
                padding: 20px 40px;
            }
        }

        &__sub-label {
            color: $ypo-blue;
            font-family: "Noto Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.23px;
            line-height: 24px;
        }

        .private_networks {
            font-size: 16px;
            letter-spacing: -0.01px;
            line-height: 22px;
        }

        .blocked-filter {
            position: absolute;
            height: 100%;
            width: 100%;
            z-index: 2;
            left: -1px;
            background-color: transparent;
        }

        .checked-box {
            &:after {
                display: block;
                left: 5px;
                top: 1px;
                width: 5px;
                height: 12px;
                border: solid #44779f;
                border-width: 0 3px 3px 0;
                -webkit-transform: rotate(45deg);
                transform: rotate(45deg)
            }
        }
    }
</style><style lang="scss">
    @import '../../../common/styles/_colors.scss';

    .filter-options__typeAhead {
        &-input {
            .v-input__slot {
                border: 2px solid $ypo-tile-border !important;
                -webkit-border-radius: 8px;
                -moz-border-radius: 8px;
                border-radius: 8px;
                min-height: 35px !important;
            }
        }

        .v-text-field--box input,
        .v-text-field--outline input {
            margin-top: 0 !important;
            padding-top: 20px !important;
            padding-bottom: 20px !important;
        }

        &-result {
            .v-input--selection-controls.v-input .v-label {
                &:hover {
                    font-weight: 600 !important;
                }
            }
        }
    }

    .location-type-ahead {
        .filter-options__typeAhead {
            margin-top: 7px;

            .v-text-field {
                padding-top: 0;
                margin-top: 5px;
            }

            &-input {
                .v-input__slot {
                    border: none !important;
                    border-radius: 0 !important;
                    border-bottom: 1px solid $ypo-gray !important;
                    min-height: 35px !important;
                }
            }
        }
    }
</style>
